module.exports = __webpack_public_path__ + "media/kommissar_1.1b.f5227c2f.mp3";